var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":'appChat',"draggable":'.drag-handle',"resizable":true,"clickToClose":false,"scrollable":true,"height":'70%',"minWidth":_vm.minWidth,"width":_vm.panelWidth,"reset":true}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }